import{ PLATFORM_ID, Component, OnInit, HostListener, ChangeDetectorRef, Input, EventEmitter, Output, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { ViewEncapsulation } from '@angular/core';
import { APP_SETTINGS } from 'angular-engine/modules/ng-express-engine/tokens';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { isPlatformBrowser, isPlatformServer} from '@angular/common';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'navmenu',
    templateUrl: 'menu.template.html',
    styleUrls: ['menu.style.scss'],
    encapsulation: ViewEncapsulation.None
})


export class NavMenu{
    @Input() routes: Array<any>;
    @Input() live: boolean = false;
    public logo:string;
    public loginName: string = "Login";
    protected isServer: boolean;
    private oauthSubscription: Subscription;
    public isLoggedIn : boolean;

    constructor(
        @Inject(APP_SETTINGS) private settings: any,
        @Inject(PLATFORM_ID) private platformId: string,
        private authService: UserLoginService,
        private interactions : EventInteraction,
        private changeDetector: ChangeDetectorRef,
    ){
        this.logo = this.settings.CLIENT_LOGO;
        this.isServer = isPlatformServer(this.platformId);
        if (!this.isServer){
            this.oauthSubscription = this.interactions.subscribe(e => {
                if (e.key == "oauth") {
                    this.checkLoginStatus();
                }
            });
        }
    }

    ngOnInit() {
        if (!this.isServer){
            this.checkLoginStatus();
        }
    }

    ngOnDestroy() {
        if(this.oauthSubscription)
        {
            this.oauthSubscription.unsubscribe();
        }
    }

    public login() {
        this.authService.toggleLoginState();
        this.isLoggedIn && this.checkLoginStatus();
    }

    public checkLoginStatus(){
        if(!this.isServer)
        {
            this.authService.checkLoginStatus();
            const newLoginName = (this.authService.loginName) ? "Logout " + this.authService.loginName : "Login";
            if (newLoginName != this.loginName){
                this.isLoggedIn = this.authService.isLoggedIn;
                this.loginName = newLoginName;
                this.changeDetector.detectChanges();
            }
            
        }
        else{
            this.isLoggedIn = false;
            this.loginName = "Login";
        }
    }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/navbar/menu.component.ts